(function () {
  const DEBUG = true;
  const LOG_PREFIX = "[DecoPrice]";

  const RETRY_DELAYS = [500, 1000, 2000, 3500, 5000];
  const PRICE_SELECTOR =
    ".bls__deco-price-group > .bls__product-price:not(.bls__deco-formatted-price)";
  const DECO_DISCOUNT_CLASS = "controll-deco-discount-applied";
  const observed = new WeakSet();

  function log(...args) {
    if (DEBUG) console.log(LOG_PREFIX, ...args);
  }

  function warn(...args) {
    if (DEBUG) console.warn(LOG_PREFIX, ...args);
  }

  function describeEl(el) {
    if (!el) return null;
    return {
      id: el.id || null,
      classes: el.className,
      hasDecoAttr: el.hasAttribute("data-deco-discount-applied"),
      hidden: el.hidden,
    };
  }

  function parseBRL(text) {
    if (!text) return null;
    const cleaned = text
      .replace(/\u00a0/g, " ")
      .replace(/[^\d,.-]/g, "")
      .trim();
    if (!cleaned) return null;

    const normalized = cleaned.includes(",")
      ? cleaned.replace(/\./g, "").replace(",", ".")
      : cleaned;

    const value = parseFloat(normalized);
    if (Number.isNaN(value)) return null;
    return Math.round(value * 100);
  }

  function formatMoney(cents) {
    if (typeof Shopify !== "undefined" && typeof Shopify.formatMoney === "function") {
      const format = window.cartStrings?.money_format || "{{amount}}";
      return Shopify.formatMoney(cents, format);
    }
    const value = (cents / 100).toFixed(2).replace(".", ",");
    return "R$ " + value;
  }

  function formatParcelValue(cents) {
    return (cents / 100).toFixed(2).replace(".", ",");
  }

  function calcParcelas(priceCents, minCents, maxParcelas) {
    let parcelas = Math.floor(priceCents / minCents);
    if (parcelas < 1) parcelas = 1;
    if (parcelas > maxParcelas) parcelas = maxParcelas;

    const valorParcela = Math.floor(priceCents / parcelas);
    if (valorParcela < minCents) return null;

    return { parcelas, valorParcela };
  }

  function buildFormattedHTML(deCents, porCents, parcelas, valorParcelaCents, isShelf) {
    if (isShelf) {
      let html =
        '<div class="bls__deco-formatted-price-shelf">' +
        '<div class="bls__deco-formatted-price-shelf-old">De: ' +
        formatMoney(deCents) +
        "</div>" +
        '<div class="bls__deco-formatted-price-shelf-new">Por: ' +
        formatMoney(porCents) +
        " (-5% no Pix)" +
        "</div>" +
        "</div>";

      if (parcelas && valorParcelaCents) {
        html +=
          '<div class="bls__deco-formatted-price-installments">' +
          parcelas +
          "x R$ " +
          formatParcelValue(valorParcelaCents) +
          "</div>";
      }

      return html;
    }

    let html =
      '<div style="font-size: 18px; color: #666; margin-bottom: 6px; line-height: 1.5; text-decoration: line-through;">' +
      "De: " +
      formatMoney(deCents) +
      "</div>" +
      '<div style="font-size: 18px; color:rgba(234, 88, 52, 0.86); margin-bottom: 6px; line-height: 1.5;">' +
      "Por: " +
      formatMoney(porCents) +
      " (-5% no Pix)" +
      "</div>";

    if (parcelas && valorParcelaCents) {
      html +=
        '<div style="font-size: 16px; color: #666; line-height: 1.5;">' +
        parcelas +
        "x R$ " +
        formatParcelValue(valorParcelaCents) +
        "</div>";
    }

    return html;
  }

  function isShelfContext(priceEl, formattedEl) {
    return (
      priceEl.classList.contains("mb-4") ||
      (formattedEl.classList.contains("mb-4") && !formattedEl.classList.contains("biger-price"))
    );
  }

  function getFormattedEl(priceEl) {
    if (priceEl.classList.contains("bls__deco-formatted-price")) {
      log("getFormattedEl: ignorado — priceEl é o bloco formatado", describeEl(priceEl));
      return null;
    }

    const group = priceEl.closest(".bls__deco-price-group");
    if (group) {
      const inGroup = group.querySelector(".bls__deco-formatted-price");
      if (inGroup) {
        log("getFormattedEl: encontrado via .bls__deco-price-group", {
          priceEl: describeEl(priceEl),
          formattedEl: describeEl(inGroup),
        });
        return inGroup;
      }
      warn("getFormattedEl: grupo encontrado, mas bloco formatado ausente", {
        priceEl: describeEl(priceEl),
        group: describeEl(group),
      });
    }

    const sibling = priceEl.nextElementSibling;
    if (sibling?.classList.contains("bls__deco-formatted-price")) {
      log("getFormattedEl: encontrado via nextElementSibling", {
        priceEl: describeEl(priceEl),
        formattedEl: describeEl(sibling),
      });
      return sibling;
    }

    if (priceEl.id?.startsWith("price-") && !priceEl.id.startsWith("price-deco-formatted-")) {
      const formattedId = "price-deco-formatted-" + priceEl.id.slice("price-".length);
      const byId = document.getElementById(formattedId);
      log("getFormattedEl: busca por ID", {
        priceId: priceEl.id,
        formattedId,
        found: !!byId,
      });
      if (byId) return byId;
    }

    warn("getFormattedEl: bloco formatado NÃO encontrado", describeEl(priceEl));
    return null;
  }

  function getDePriceCents(priceEl, formattedEl) {
    const originalEl = priceEl.querySelector(".deco-original-price > div:first-child");
    const fromDom = parseBRL(originalEl?.textContent);

    if (fromDom !== null) {
      log("getDePriceCents: via DOM deco-original-price", {
        raw: originalEl?.textContent?.trim(),
        cents: fromDom,
      });
      return fromDom;
    }

    const fromFormatted = parseInt(formattedEl?.dataset.variantPrice, 10);
    if (fromFormatted > 0) {
      log("getDePriceCents: via data-variant-price (formattedEl)", fromFormatted);
      return fromFormatted;
    }

    const fromGroup = parseInt(
      priceEl.closest(".bls__deco-price-group")?.dataset.variantPrice,
      10
    );
    if (fromGroup > 0) {
      log("getDePriceCents: via data-variant-price (grupo)", fromGroup);
      return fromGroup;
    }

    warn("getDePriceCents: falhou — nenhuma fonte válida", {
      hasOriginalEl: !!originalEl,
      originalText: originalEl?.textContent?.trim(),
      formattedDataset: formattedEl?.dataset,
      groupDataset: priceEl.closest(".bls__deco-price-group")?.dataset,
    });
    return null;
  }

  function getDiscountCents(priceEl) {
    const discountEl = priceEl.querySelector(".deco-discount-price");
    if (!discountEl) {
      warn("getDiscountCents: .deco-discount-price não encontrado", describeEl(priceEl));
      return null;
    }

    const raw = discountEl.textContent || discountEl.innerText;
    const cents = parseBRL(raw);
    log("getDiscountCents", { raw: raw?.trim(), cents });
    return cents;
  }

  function setDecoDiscountClass(priceEl, active) {
    if (priceEl.classList.contains("bls__deco-formatted-price")) return;

    const isProductPage = priceEl.classList.contains("biger-price");
    const isShelf =
      priceEl.classList.contains("mb-4") && !!priceEl.closest(".bls__deco-price-group");

    if (!isProductPage && !isShelf) {
      warn("setDecoDiscountClass: ignorado — não é PDP nem vitrine", describeEl(priceEl));
      return;
    }

    priceEl.classList.toggle(DECO_DISCOUNT_CLASS, active);
    log("setDecoDiscountClass", {
      active,
      isProductPage,
      isShelf,
      el: describeEl(priceEl),
    });
  }

  function hideFormattedBlock(formattedEl) {
    if (!formattedEl) return;
    formattedEl.hidden = true;
    formattedEl.innerHTML = "";
    log("hideFormattedBlock", describeEl(formattedEl));
  }

  function updateDecoFormattedPrice(priceEl, source) {
    log("updateDecoFormattedPrice: início", { source, priceEl: describeEl(priceEl) });

    if (!priceEl || priceEl.classList.contains("bls__deco-formatted-price")) {
      warn("updateDecoFormattedPrice: abortado — priceEl inválido ou é bloco formatado");
      return;
    }

    const formattedEl = getFormattedEl(priceEl);
    if (!formattedEl) {
      warn("updateDecoFormattedPrice: abortado — formattedEl não encontrado", describeEl(priceEl));
      return;
    }

    if (!priceEl.hasAttribute("data-deco-discount-applied")) {
      log("updateDecoFormattedPrice: desconto Deco inativo — ocultando bloco");
      setDecoDiscountClass(priceEl, false);
      hideFormattedBlock(formattedEl);
      return;
    }

    const deCents = getDePriceCents(priceEl, formattedEl);
    const discountCents = getDiscountCents(priceEl);

    if (deCents === null || discountCents === null) {
      warn("updateDecoFormattedPrice: abortado — valores inválidos", {
        deCents,
        discountCents,
      });
      setDecoDiscountClass(priceEl, false);
      hideFormattedBlock(formattedEl);
      return;
    }

    const minCents = parseInt(formattedEl.dataset.parcelMin, 10) || 1000;
    const maxParcelas = parseInt(formattedEl.dataset.parcelMax, 10) || 6;
    const parcelData = calcParcelas(discountCents, minCents, maxParcelas);
    const shelf = isShelfContext(priceEl, formattedEl);

    formattedEl.innerHTML = buildFormattedHTML(
      deCents,
      discountCents,
      parcelData?.parcelas,
      parcelData?.valorParcela,
      shelf
    );
    formattedEl.hidden = false;
    setDecoDiscountClass(priceEl, true);

    log("updateDecoFormattedPrice: sucesso", {
      deCents,
      discountCents,
      parcelData,
      isShelf: shelf,
      formattedEl: describeEl(formattedEl),
    });
  }

  function observePriceElement(priceEl) {
    if (!priceEl || observed.has(priceEl)) return;
    observed.add(priceEl);

    log("observePriceElement: registrando observer", describeEl(priceEl));
    updateDecoFormattedPrice(priceEl, "observe");

    const observer = new MutationObserver(function () {
      log("MutationObserver: mudança detectada", describeEl(priceEl));
      updateDecoFormattedPrice(priceEl, "mutation");
    });

    observer.observe(priceEl, {
      attributes: true,
      attributeFilter: ["data-deco-discount-applied"],
      childList: true,
      subtree: true,
    });
  }

  function scanAndObserve(root) {
    if (root.nodeType !== 1) return;

    const matched = root.matches?.(PRICE_SELECTOR) ? [root] : [];
    const found = [
      ...matched,
      ...Array.from(root.querySelectorAll?.(PRICE_SELECTOR) || []),
      ...Array.from(
        root.querySelectorAll?.(
          '.bls__product-price[data-deco-discount-applied]:not(.bls__deco-formatted-price)'
        ) || []
      ),
    ];

    if (found.length) {
      log("scanAndObserve: elementos encontrados", {
        root: root === document ? "document" : describeEl(root),
        count: found.length,
        elements: found.map(describeEl),
      });
    }

    if (root.matches?.(PRICE_SELECTOR)) {
      observePriceElement(root);
    }

    root.querySelectorAll(PRICE_SELECTOR).forEach(observePriceElement);

    root
      .querySelectorAll?.(
        '.bls__product-price[data-deco-discount-applied]:not(.bls__deco-formatted-price)'
      )
      .forEach(observePriceElement);
  }

  function refreshAllPrices(source) {
    const priceEls = [
      ...document.querySelectorAll(PRICE_SELECTOR),
      ...document.querySelectorAll(
        '.bls__product-price[data-deco-discount-applied]:not(.bls__deco-formatted-price)'
      ),
    ];

    log("refreshAllPrices", {
      source,
      count: priceEls.length,
      elements: priceEls.map(describeEl),
    });

    priceEls.forEach(function (el) {
      updateDecoFormattedPrice(el, source || "refresh");
    });
  }

  function init() {
    log("init: script carregado", {
      template: document.body?.className,
      priceGroups: document.querySelectorAll(".bls__deco-price-group").length,
      productPriceBlocks: document.querySelectorAll(PRICE_SELECTOR).length,
      decoAppliedBlocks: document.querySelectorAll(
        '.bls__product-price[data-deco-discount-applied]:not(.bls__deco-formatted-price)'
      ).length,
      formattedBlocks: document.querySelectorAll(".bls__deco-formatted-price").length,
    });

    scanAndObserve(document);

    RETRY_DELAYS.forEach(function (delay) {
      setTimeout(function () {
        refreshAllPrices("retry-" + delay + "ms");
      }, delay);
    });

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          scanAndObserve(node);
        });

        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "data-deco-discount-applied" &&
          mutation.target.matches?.(
            '.bls__product-price:not(.bls__deco-formatted-price)'
          )
        ) {
          log("MutationObserver (body): data-deco-discount-applied alterado", {
            target: describeEl(mutation.target),
          });
          observePriceElement(mutation.target);
          updateDecoFormattedPrice(mutation.target, "body-attr-mutation");
        }
      });
    }).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["data-deco-discount-applied"],
    });

    document.addEventListener("change", function (event) {
      const variantSelects = event.target.closest("variant-selects");
      if (!variantSelects) return;
      log("change: variante alterada — agendando refresh");
      RETRY_DELAYS.forEach(function (delay) {
        setTimeout(function () {
          refreshAllPrices("variant-change-" + delay + "ms");
        }, delay);
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
